<template>
  <WdsSelect
    v-model="selectedCompanies"
    can-deselect
    multi-select
    searchable
    labels-primary
    max-labels-visible="3"
    :disabled="loading"
    :label="$t('Companies')"
    :list="companies"
    :placeholder="$t('All')"
    data-test="tc-filter-companies"
  />
</template>

<script setup lang="ts">
import { computed, ModelRef } from 'vue'
import { WdsSelect } from '@worksome/wds-components'

import { $t } from '@/composables/translation'
import { AccountStoreType } from '@/components/GraphqlDataTable/filters/accounts/accounts-store'
import { useCompanyAccounts } from '@/components/GraphqlDataTable/composables'

defineProps({
  modelValue: {
    type: Array,
    default: [],
  },
})

const { accounts, loading } = useCompanyAccounts({
  useSubdivisions: true,
})

const companies = computed(() =>
  accounts.value
    .slice()
    .sort((divisionA, divisionB) => divisionA.name.trim().localeCompare(divisionB.name.trim())),
)

const selectedCompanies: ModelRef<AccountStoreType[]> = defineModel({
  default: () => [],
})
</script>
